import { ShieldCheck, PiggyBank, TrendingUp } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const WINS = [
  {
    icon: ShieldCheck,
    title: "Real lawsuit protection",
    body: "Fixing the actual code — labels, headings, contrast, alt text, keyboard access — is what closes barriers. No one can promise zero claims, but closed gaps are your best defense.",
    accent: "text-safe",
    ring: "hover:border-safe/50",
  },
  {
    icon: PiggyBank,
    title: "Up to $5,000 back from the IRS",
    body: "Eligible small businesses can claim the Disabled Access Credit (Form 8826): 50% of accessibility costs over $250, up to $5,000 a year. Ask your tax professional.",
    accent: "text-brandamber",
    ring: "hover:border-brandamber/50",
  },
  {
    icon: TrendingUp,
    title: "More customers, better AI Findability",
    body: "More than 1 in 4 U.S. adults live with a disability. Accessible sites serve them all — and search engines reward accessible structure with better rankings.",
    accent: "text-cy",
    ring: "hover:border-cy/50",
  },
];

export const BigWins = () => (
  <section className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>COMPLIANCE PAYS FOR ITSELF</Eyebrow>
        <h2 className="mt-4 max-w-3xl font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-white">
          THE 3 BIG WINS <span className="text-brandamber">NOBODY TELLS YOU.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {WINS.map((w, i) => (
          <Reveal key={w.title} delay={i * 0.08} className="h-full">
            <div className={`h-full rounded-2xl border border-white/10 bg-panel p-7 sm:p-8 transition-all hover:-translate-y-1 ${w.ring}`}>
              <w.icon className={`h-10 w-10 ${w.accent}`} />
              <h3 className="mt-5 text-xl font-semibold text-white">{w.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{w.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
